import { render, staticRenderFns } from "./RegistrosComplemento.vue?vue&type=template&id=519ded4e&scoped=true&"
import script from "./RegistrosComplemento.vue?vue&type=script&lang=js&"
export * from "./RegistrosComplemento.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosComplemento.vue?vue&type=style&index=0&id=519ded4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ded4e",
  null
  
)

export default component.exports